const burger = (menuSelector, burgerSelector) => {
    const menuElem = document.querySelector(menuSelector),
          burgerElem = document.querySelector(burgerSelector);

    menuElem.style.display = "none";   //  вручную скрываем меню что б при инициализации меню случайно не показалась у пользователя на екране

    burgerElem.addEventListener("click", () => {   // отслеживание действий которые происходят на бургере
        if (menuElem.style.display == "none" && window.screen.availWidth < 993) {
            menuElem.style.display = "block";
        } else {
            menuElem.style.display = "none";
        }
    }); 
    
    window.addEventListener("resize", () => {
        if (window.screen.availWidth > 992) {
            menuElem.style.display = "none";
        }
    });
};

export default burger;

